import { Checkbox, CheckboxProps, FormControlLabel } from "@mui/material";
import { IGWidget } from "../GWidget";

export default function CheckButton(props:IGWidget&CheckboxProps&{label:string}){
    const {label, ...checkboxProps} = props
    return <FormControlLabel label={label} control={<Checkbox {...checkboxProps}/>}/>
}